export default {
  indicatorStyle: 'black',
  widthCountList: 558,
};
